import React, {useState, useEffect} from 'react'
import Template from '../component/template'
import {LoadEffect, TableLoader}  from '../component/loader'
import axios from 'axios'
import {Alerts} from '../component/notify'
import PageHeader from '../component/pageheader'
import {Currency, FormatNumber, ServerUrl,  Token, config} from '../component/include'
import Select from 'react-select'

import BootstrapTable from 'react-bootstrap-table-next';
import cellEditFactory from 'react-bootstrap-table2-editor';
import {Type} from 'react-bootstrap-table2-editor';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import { longDate } from '../component/globalFunction'
import { userToken } from '../component/authentication'
import { Link } from 'react-router-dom'

const BookIssueReport =()=> {
    const [errors, setErrors] = useState({});
    
    const [notice, setNotice] = useState({
        isLoading : false, 
        isDataFetching: false,
    });

    
    
    const [students, setStudents] = useState([]);  
    const [bookIssued, setBookIssued]= useState([])
    const [books, setBooks]= useState([])
    const [list, setList] = useState({
        
        student:[],
        book:[],
        dataType:[],
        from:'',
        to:'',
        returnDate:''
    })
    
    


const fetchStudents =()=>{
  const fd = new FormData();
        fd.append('jwt', Token); 
        let url = ServerUrl+'/fetch_controller/tbl_students'
        axios.post(url, fd, config).then(result=>setStudents(result.data))
    }

const fetchBooks =()=>{
  const fd = new FormData();
        fd.append('jwt', Token); 
        let url = ServerUrl+'/fetch_controller/tbl_books'
        axios.post(url, fd, config).then(result=>setBooks(result.data))
    }


    const handleSelect = (option, action)=>{
        setList({...list, [action.name]: option});
        setErrors({...errors, [action.name]:''})
         }
  
         const handleChange = event =>{
           const {name, value} = event.target
           setList({...list, [name]: value});
           setErrors({...errors, [name]:''})
       }


const fetchBookIssueReport =()=>{
             
        setNotice({...notice, 
            isDataFetching: true
        });

let sql = "Select b.bookName, b.authorName, s.studentName, i.bookCode, i.fine, i.userType, s.admissionNumber, s.mobile, i.ID, i.code,  i.dateIssue, i.issuedCount, i.dateReturn, i.userCode,   i.remarks,   i.returnedDate, i.returnStatus from tbl_book_issued i, tbl_students s, tbl_books b where i.bookCode = b.code and i.userCode = s.code and i.usertype='Student' "

if(list.student.length !==0 ){
    sql = sql + " and i.userCode ='"+list.student.value+"'"
}

if(list.book.length !==0 ){
      sql = sql + " and i.bookCode ='"+list.book.value+"'"
  }

if(list.dataType.length !==0 ){
      sql = sql + " and i.returnStatus ='"+list.dataType.value+"'"
  }

  if(list.returnDate ){
      sql = sql + " and i.returnedDate ='"+list.returnDate+"'"
     
  }

  if(list.from !== '' && list.to !== ''){
    sql = sql + " and i.dateIssue BETWEEN '"+list.from+"' and '"+list.to+"'"
}

const fd = new FormData();
        fd.append('jwt', Token); 
fd.append("sql", sql);
let url = ServerUrl+'/fetchBySql_controller'
axios.post(url, fd, config).then(result=>{ 
    setBookIssued(result.data)
    setNotice({...notice, 
        isDataFetching: false
    });

    window.scrollTo(0,document.body.scrollHeight);

})
.catch((error)=>{
Alerts('Error!', 'danger', error.message)
})

    

}

   
	
let i =1;
const tableHeader = [
{dataField: 'code', text: 'SNo', footer:'SNo', formatter:()=>i++, csvExport: false},
        {dataField: 'studentName', footer:'Issued To', text: 'Issued To', formatter: (cell, row)=><span style={{display:'block', width:300, whiteSpace:'normal', wordWrap:'break-word' }}>({row.admissionNumber}) {cell}  </span> },
        {dataField: 'bookName', text: 'Book Title', footer:'Book Title', formatter: (cell, row)=><span style={{display:'block', width:300, whiteSpace:'normal', wordWrap:'break-word' }}> {cell} ({row.authorName}) </span>},       
        {dataField: 'dateIssue', text: 'Date of Issue', footer:'Date of Issue', formatter:(cell,row)=>
        longDate(cell)},
    {dataField: 'dateReturn', text: 'Date to Return', footer:'Date to Return',  formatter:(cell,row)=>
    longDate(cell)}, 
    {dataField: 'returnedDate', text: 'Returned Date', footer:'Return Date', formatter:(cell,row)=>cell!=="0000-00-00"?
    longDate(cell):'Not Yet Return'},
    {dataField: 'fine', text: 'Fine', formatter:(cell,row)=>Currency+FormatNumber(cell), footer:columnData => Currency+FormatNumber(columnData.reduce((acc, item) => Number(acc) + Number(item), 0))}
 ];
 

 
 const BookTable=(props)=>{

    const CustomToggleList = ({
        columns,
        onColumnToggle,
        toggles
      }) => ( 
      <div  className="btn-group btn-group-toggle btn-group-vertical" data-toggle="buttons">
          {
            columns
              .map(column => ({
                ...column,
                toggle: toggles[column.dataField]
              }))
              .map(column => (
                
                <button
                  type="button"
                  key={ column.dataField }
                  className={ ` btn btn-primary ${column.toggle ? 'active' : ''}` }
                  data-toggle="button"
                  aria-pressed={ column.toggle ? 'true' : 'false' }
                  onClick={ () => onColumnToggle(column.dataField) }
                >
                  { column.text }
                </button>
              ))
          }
        </div>
        
      );

    
     const { SearchBar } = Search;
 
     const customTotal = (from, to, size) => (
        <span >&nbsp;Showing { from } to { to } of { size } items</span>
      );
     const options = {
         showTotal: true,
     paginationTotalRenderer: customTotal,
     sizePerPageList: [{text: '100', value: 100}, {text: '200', value: 200}, {text: '500', value: 500},
     { text: 'All', value: props.data.length }]
        
       };
  
     return <ToolkitProvider search columnToggle 
                 keyField='ID' data={ props.data } columns={ props.columns } >
                     
                     {
                         props => (
                         <div >
                           <div className="form-group">
                             <SearchBar
                             { ...props.searchProps } style={{height:'40px'}} className="form-control" placeholder="Type to search!!!" />
                             &nbsp;
                           
                             <div className="btn-group dropdown-split-success">
  
  <button type="button" className="btn btn-primary dropdown-toggle dropdown-toggle-split waves-effect waves-light" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
  <i className="fa fa-search-plus"></i> Columns
  </button>
  
  <div className="dropdown-menu" x-placement="bottom-start" style={{overflow:'scroll', height:'260px', width:'250px', position: 'absolute', transform: 'translate3d(113px, 40px, 0px)', top: '0px', left: '0px', willChange: 'transform'}}>
    <CustomToggleList { ...props.columnToggleProps } />
  </div>
  </div>

  <div className="dt-buttons btn-group pull-right"> 
  <a href="/library/issues_return/student" className="btn btn-outline-success waves-effect waves-light" >
        <i className="fa fa-plus"></i>Issue & Return Book </a>	


<div className="btn-group dropdown-split-primary ">
    <button type="button" className="btn btn-outline-primary dropdown-toggle dropdown-toggle-split waves-effect waves-light" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        <i className="fa fa-download"></i>Export
    </button>
    <div className="dropdown-menu" x-placement="bottom-start" style={{ position: 'absolute', transform: 'translate3d(110px, 40px, 0px)', top: '0px', left: '0px', willChange: 'transform'}}>


           
<form method='POST' action={ServerUrl+'/excel_controller.php?api=issueReport'} target='_blank'>

<input type='hidden' name='jwt' value ={Token} />
<input type='hidden' name='student' value ={list.student.value} />
<input type='hidden' name='book' value ={list.book.value} />
<input type='hidden' name='dataType' value ={list.dataType.value} />

<input type='hidden' name='returnDate' value ={list.returnDate} />
<input type='hidden' name='from' value ={list.from} />
<input type='hidden' name='to' value ={list.to} />
<button type="submit" className="btn dropdown-item waves-effect waves-light" > Export To Excel</button>

</form>

<form method='POST' action={ServerUrl+'/printout/issue_report.php?token='+userToken} target='_blank'>
<input type='hidden' name='student' value ={list.student.value} />
<input type='hidden' name='book' value ={list.book.value} />
<input type='hidden' name='dataType' value ={list.dataType.value} />

<input type='hidden' name='returnDate' value ={list.returnDate} />
<input type='hidden' name='from' value ={list.from} />
<input type='hidden' name='to' value ={list.to} />

<input type='hidden' name='jwtToken' value ={Token} />
<button type="submit" className="btn dropdown-item waves-effect waves-light" > Print Preview</button>

</form>
       
    </div>
</div> 
</div> 
  
                             </div>
                             
                      
             
                             <BootstrapTable
                             { ...props.baseProps }
                                         striped
                                     hover
                                     condensed
                                     noDataIndication={<div className="alert alert-danger background-danger">No Record Found</div>}
                                 pagination={paginationFactory(options) }
                                 
                             />
                         </div>
                         )
                     }
  </ToolkitProvider>
  }



useEffect(()=>{
    fetchStudents();
    fetchBooks();
    fetchBookIssueReport()
},[]);



        return (  
   <>{notice.isLoading ?<LoadEffect className="overlay floatLoad" /> : "" }
   <div  className="main-body">
                <div className="page-wrapper">
                 
                   {/* <!-- Page-header start --> */}

        <PageHeader title="Library Books Isuued - Student">
        <li className="breadcrumb-item"><a  href="#!"> <i className="fa fa-fw fa-book"></i> </a>
                            </li>
                            <li className="breadcrumb-item"><a href="#!">Library</a> </li>
                            <li className="breadcrumb-item"><a href="#!">Report</a> </li>
                    <li className="breadcrumb-item"><a href="#!">Books Issue Report</a> </li>
                    </PageHeader>
{/* The Page Body start here */}
                <div className="page-body">
                <div className="row  ">
   <div className="col-sm-12">

<div className="card z-depth-0">
    <div className="card-block">
    <div className="card z-depth-0">
        <div className="card-block">

        <Link to="/library/book_issue_report/student" className="btn btn-success "> <i className="fa fa-graduation-cap"></i> Student</Link>&nbsp;&nbsp;
<Link to="/library/book_issue_report/staff" className="btn btn-danger "> <i className="fa fa-user"></i> Staff</Link>





</div>
</div></div>
</div>

</div>  </div>
                <div className="row  ">
							

	<div className="col-sm-12">
    <div className="card z-depth-0">
		<div className="card-header">
			<h5><i className="fa fa-edit" ></i> Define Search</h5>
			<div className="card-header-right">
				<ul className="list-unstyled card-option">
					<li><i className="feather icon-maximizes full-card"></i></li>
					<li><i className="feather icon-minus minimize-card"></i></li>
					<li><i className="feather icon-trash-2 close-card"></i></li>
				</ul>
			</div>
		</div><div className="card-block">
        <div className="card z-depth-0">
		<div className="card-block">
		<div className="row">
									
										<section className="col-md-4">
<div className="form-group">
						<label>Select Student</label>
						<Select  options={
                            students.map((list, idx)=> {
                               return {key:idx, value: list.code, label: list.admissionNumber, studentName:list.studentName, co:list.fatherName, phone:list.father_mobile  }
                             })} 
                        getOptionLabel={option =>`(${option.label}) ${option.studentName} C/O  ${option.co}  ${option.phone}`}
onChange={handleSelect}  name="student" value={list.student}  /> 
											</div>

                            
</section>

<section className="col-md-4">
<div className="form-group">
						<label >Select Book </label>
                        <Select options={
                            books&&books.map((lst, idx)=> {
                               return {key:idx, value: lst.code, label: lst.bookName, aut:lst.authorName }
                             })} 
                             getOptionLabel={option =>`${option.label} (${option.aut})`}
onChange={handleSelect} name="book" value={list.book}  /> 
			</div>
</section>
            <section className="col-md-4">

            <div className="form-group">
						<label >Type</label>
                        <Select  options={[
                    { value: 'Yes', label: 'Already Returned' },
                    { value: 'No', label: 'Not Yet Return' },
                ]} 
        onChange={handleSelect}  name="dataType" value={list.dataType}  /> 
			</div>
</section>
</div>

<div className="row">
<section className="col-md-4">
<div className="form-group">
						<label >From Date</label>
		<input type="date" name="from" className='form-control'   value={list.from}  onChange={handleChange}  /> 
			</div>
</section>


<section className="col-md-4">
<div className="form-group">
						<label >To Date</label>
		
                        <input type="date" name="to" className='form-control'  value={list.to}  onChange={handleChange}  /> 	
			</div>
</section>


<section className="col-md-4">

<div className="form-group">
						<label >Returned Date</label>
		<input type="date" name="returnDate" id="returnDate"  value={list.returnDate}  onChange={handleChange} className='form-control' /> 
			</div>
</section>

				</div>	

	<footer className="pull-right">
	<button type="button" id="submit" onClick={fetchBookIssueReport} className="btn btn-inverse "><i className="fa fa-search"></i> Proceed</button>
								</footer>				
							</div>
                            </div>
							</div></div>
</div>

</div>
	
{bookIssued.length!==0?
<div className="row  ">   <div className="col-sm-12">
                               
                                                
<div className="card z-depth-0">
            <div className="card-header">
                <h5><i className="fa fa-th" ></i> Listing All Books</h5>
                <div className="card-header-right">
                    <ul className="list-unstyled card-option">
                        <li><i className="feather icon-maximizes full-card"></i></li>
                        <li><i className="feather icon-minus minimize-card"></i></li>
                        <li><i className="feather icon-trash-2 close-card"></i></li>
                    </ul>
                </div>
            </div>
            <div className="card-block">
            <div className="col-md-12 table-responsive">

         {notice.isDataFetching ? <TableLoader />:
         <BookTable data={bookIssued}  columns={tableHeader}  /> 
        } 

            </div></div></div>

    
    </div>
    </div>:''}




   </div>
          {/* The Page Body close here */}

            </div>
            </div>

</> 
 );
        
}

export default React.memo(BookIssueReport) 